import React from 'react';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';

const TransportationRequestDetails = ({ transportationResources }) => {

    return (
        <>
            {
                transportationResources.map((resource, index) =>
                    <Paper key={index} className="detail-wrapper">
                        <Typography variant="button" display="block" gutterBottom>
                            {resource.goingFromDestinationName}, {resource.goingToDestinationName}
                        </Typography>
                        <Typography variant="subtitle2" display="block" gutterBottom>
                            {resource.noofPersons} Person, By {resource.vehicleType}, {resource.goingDate.substring(0, 10)} {resource.goingTime.substring(0, 5)}
                        </Typography>
                        <Typography variant="subtitle2" display="block" gutterBottom>
                            STOPS: [{resource.stop1}  {resource.stop2}  {resource.stop3}  {resource.stop4}]
                        </Typography>
                        <Typography variant="subtitle2" display="block" gutterBottom>
                            CONTACT: {resource.contactPerson} {resource.contactPersonTel}
                        </Typography>
                        {
                            resource.note && resource.note.trim() !== "" ?
                                <Typography variant="body2" display="block" gutterBottom>
                                    Notes: {resource.note}
                                </Typography>
                                : null
                        }
                    </Paper>
                )
            }
        </>
    )
}

export default TransportationRequestDetails;